export default "__VITE_ASSET__DYNKUf9O__"